import * as React from "react";
const SvgAngles = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	width: "1em",
	height: "1em",
	...props
}, /* @__PURE__ */ React.createElement("defs", null), /* @__PURE__ */ React.createElement("g", {
	id: "angles_svg__Layer_2",
	"data-name": "Layer 2"
}, /* @__PURE__ */ React.createElement("g", {
	id: "angles_svg__Layer_1-2",
	"data-name": "Layer 1"
}, /* @__PURE__ */ React.createElement("path", {
	d: "M0 0h24v24H0z",
	style: { fill: "none" }
}), /* @__PURE__ */ React.createElement("path", {
	d: "M12.89 20H3.43L6 13.12l.69-1.88 2.93-8A1 1 0 0 0 9 2a1 1 0 0 0-1.28.59l-2.91 7.9-.7 1.88-2.55 6.93A2 2 0 0 0 3.44 22H21a1 1 0 0 0 1-1 1 1 0 0 0-1-1Z",
	style: { fill: "currentColor" }
}), /* @__PURE__ */ React.createElement("path", {
	d: "M16.5 17a3.5 3.5 0 1 1 3.5-3.5 3.5 3.5 0 0 1-3.5 3.5m0-5a1.5 1.5 0 1 0 1.5 1.5 1.5 1.5 0 0 0-1.5-1.5M6.66 11.24 6 13.12a10 10 0 0 1 1.34.88l1.27-1.52a11 11 0 0 0-1.95-1.24M10.54 18.65a9 9 0 0 1 .33 1.35h2a11 11 0 0 0-.35-1.64ZM10.07 13.87l-1.29 1.56a9.4 9.4 0 0 1 .92 1.32l2.09-.3a11.3 11.3 0 0 0-1.72-2.58",
	style: { fill: "currentColor" }
}))));
export default SvgAngles;
